/* eslint-disable */

define([
  'require',
  'app/controller/index',
  'app/job-wizard',
  'app/company-dashboard',
  'app/modules/utilities',
  'app/modules/header',
  'app/modules/confirmModal',
  'app/modules/user',
  'app/modules/forms',
  'actioncable',
  'vendor/jquery.slideandswipe.js', // index 10
  'js-cookie',                      // index 11
  'vendor/countable.js',           // index 12
  'jquery_ui',                      // index 13
  'src/helpers'                     // index 14
], (
  require,
  controller,
  job_wizard,
  company_dashboard,
  Util,
  Header,
  ConfirmModal,
  User,
  Forms,
  actionCable,
  slideAndSwipe,     // ✅ index 10
  Cookie,            // ✅ index 11
  Countable,         // ✅ index 12
  jQueryUI,          // ✅ index 13
  helpers            // ✅ index 14
) => {

  let instance = null;

  let App = function () {
    this.name = 'app';

    if (window.appConf) {
      console.log(window.appConf);
    }

    console.log('init App');

    initializeConsumers();
    handleCookiePolicy();

    window.imReady = true;

    Header();

    let controller = require('app/controller/index')();
  };

  App.prototype.bodyClassName = null;

  let getInstance = function () {
    if (!instance) {
      instance = new App();
    }

    return instance;
  };

  var initializeConsumers = function () {
    window.CableApp = {};

    if (User.isSignedIn()) {
      window.CableApp.cable = actionCable.createConsumer();

      window.CableApp.notifications = CableApp.cable.subscriptions.create(
        'NotificationsChannel',
        {
          connected() {
            console.log('Connected to Socket');
          },
          received(data) {
            toastr.success(data.message);
          },
        },
      );
    }
  };

  const cookieLib = Cookie.default || Cookie;

  const handleCookiePolicy = () => {
    const cookiePolicyAcceptance = Boolean(cookieLib.get('cookiePolicy'));
    if (!cookiePolicyAcceptance) {
      const $cookiePolicyBar = $('.cookie-policy-bar');
      $cookiePolicyBar.removeClass('dn');
      $cookiePolicyBar.find('.accept-cookie-policy-btn').on('click', () => {
        saveCookiePolicyAcceptance();
        $cookiePolicyBar.addClass('dn');
      });
    }
  };

  const saveCookiePolicyAcceptance = () => {
    cookieLib.set('cookiePolicy', true, {
      expires: new Date('Fri, 31 Dec 9999 23:59:59 GMT'),
      domain: `.${helpers.getUrlDomain().split('.').slice(-2).join('.')}`
    });
  };
  

  $('[data-toggle="tooltip"]').tooltip();
  $('input.radio-icheck').iCheck({ handle: 'radio' });
  $('input.checkbox-icheck').iCheck({ handle: 'checkbox' });
  $('.chosen-select-with-search').chosen({
    disable_search_threshold: 10,
    width: '100%',
    allow_single_deselect: true,
  });
  $('.js-chosen-custom-values').chosen({
    disable_search_threshold: 10,
    width: '100%',
    allow_single_deselect: true,
    allow_custom_values: true,
    no_results_text: 'No result found. Press enter to add ',
  });

  Util.datepickerMonth();
  Util.datepickerYearMonth();
  Util.datepickerYearMonthDay();

  $(document).on('nested:fieldAdded', (event) => {
    var field = event.field;
    Util.setMonthDateTimePicker(field);
  });

  let slink = document.querySelectorAll('a.social-share-link');
  for (let a = 0; a < slink.length; a++) {
    slink[a].onclick = PopupHandler;
  }

  function PopupHandler(e) {
    let height = 500;
    let width = 500;
    let url = $(this).attr('href');
    let px = Math.floor(((screen.availWidth || 1024) - width) / 2),
      py = Math.floor(((screen.availHeight || 700) - height) / 2);

    let popup = window.open(
      url,
      'Social',
      `width=${ 
        width 
        },height=${ 
        height 
        },left=${ 
        px 
        },top=${ 
        py 
        },location=0,menubar=0,toolbar=0,status=0,scrollbars=1,resizable=1`,
    );
    if (popup) {
      popup.focus();
      if (e.preventDefault) e.preventDefault();
      e.returnValue = false;
    }
    return popup;
  }

  $('.modal.js-video-modal').on('hide.bs.modal', function () {
    let f = $(this).find('iframe');
    let ff = f.clone();
    f.remove();
    $(this)
      .find('.modal-body')
      .html(ff);
  });

  $('#sign-in-modal').on('show.bs.modal', (e) => {
    var applicant_email = $('form .type-email').val();
    $(e.currentTarget)
      .find('.form-errors')
      .remove();
    if (applicant_email)
      $(e.currentTarget)
        .find('#user_email')
        .val(applicant_email);
  });

  $('#per_page').change(function () {
    let newPerPage = $(this).val();
    window.location.href = Util.updateMultipleParameters(window.location.href, {
      per_page: newPerPage,
      page: 1,
    });
  });

  $(".ca-switcher:not('.mandatory')").on('click', function () {
    let $el = $(this);
    Forms.toggleSwitcher($el);
  });

  ConfirmModal();

  $(document).on('autocompleteopen', 'input.autocomplete_filter_input, .global-search', function () {
    const $input = $(this);
    const $menu = $input.autocomplete('widget');
    $menu.width($input.innerWidth());
  });

  /*
  jQuery.ui.autocomplete.prototype._resizeMenu = function () {
    let ul = this.menu.element;
    ul.innerWidth(this.element.innerWidth());
  };
  */

  window.mainApp = { getInstance };
});
